var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('TheBanner'),_c('div',{staticClass:"container page"},[_c('div',{staticClass:"row"},[_c('HomeGlobalFeed'),_c('PopularTagList')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }